import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const ClockIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 11,
  height = 11,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-497.000000, -55.000000)">
          <g transform="translate(497.000000, 55.000000)">
            <path
              d="M0.5,5.5 C0.5,2.743 2.743,0.5 5.5,0.5 C8.257,0.5 10.5,2.743 10.5,5.5 C10.5,8.257 8.257,10.5 5.5,10.5 C2.743,10.5 0.5,8.257 0.5,5.5 Z"
              fill="#ffffff"
              className={styles.white}
            />
            <path
              d="M5.5,0 C2.463,0 0,2.463 0,5.5 C0,8.537 2.463,11 5.5,11 C8.537,11 11,8.537 11,5.5 C11,2.463 8.537,0 5.5,0 M5.5,1 C7.981,1 10,3.019 10,5.5 C10,7.981 7.981,10 5.5,10 C3.019,10 1,7.981 1,5.5 C1,3.019 3.019,1 5.5,1"
              fill="#000000"
              className={styles.defaultColor}
            />
            <g transform="translate(5.500000, 2.000000)">
              <polyline fill="#ffffff" className={styles.white} points="0 0 0 3.5 3 3.5" />
              <polyline
                points="0 0 0 3.5 3 3.5"
                stroke="#000000"
                className={styles.defaultStrokeColor}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.5"
              />
            </g>
          </g>
        </g>
      </g>
    </Icon>
  )
}
